"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomEventHelper = void 0;
var environment_helper_1 = require("./environment.helper");
exports.CustomEventHelper = {
    subscribe: function (eventName, listener) {
        if (environment_helper_1.EnvironmentHelper.isClientSide() && typeof document === "object") {
            document.addEventListener(eventName, listener);
        }
    },
    unsubscribe: function (eventName, listener) {
        if (environment_helper_1.EnvironmentHelper.isClientSide() && typeof document === "object") {
            document.removeEventListener(eventName, listener);
        }
    },
    publish: function (eventName, data) {
        if (data === void 0) { data = {}; }
        return new Promise(function (resolve, reject) {
            if (environment_helper_1.EnvironmentHelper.isClientSide() && typeof document === "object") {
                var event_1 = new CustomEvent(eventName, {
                    detail: __assign({ resolve: resolve, reject: reject }, data),
                });
                document.dispatchEvent(event_1);
            }
            else {
                reject("Error: CustomEventHelper.publish() is not available on server side.");
            }
        });
    },
};
